import { WORLD_COMPOSITIONS } from './generatedWorldExpansion'
import { WORLD_FORGE_COMPOSITIONS } from './generatedWorldForge'

export type ArenaStructuralAuthority='expansion'|'forge'|'legacy'

export type ArenaCompositionPlan={
  authority:ArenaStructuralAuthority
  dressing:boolean
  dressingGeometry:boolean
  expansion:boolean
  forge:boolean
  construction:boolean
  constructionGeometry:boolean
  ecosystemArchitecture:boolean
  landmark:boolean
  structuralWriterCount:number
}

export function arenaCompositionPlan(arenaId:string):ArenaCompositionPlan{
  const expansion=Boolean(WORLD_COMPOSITIONS[arenaId])
  const forge=!expansion&&arenaId in WORLD_FORGE_COMPOSITIONS
  const authority:ArenaStructuralAuthority=expansion?'expansion':forge?'forge':'legacy'
  const landmark=authority==='legacy'
  const structuralWriterCount=[expansion,forge,landmark].filter(Boolean).length
  return{
    authority,
    dressing:true,
    dressingGeometry:authority==='legacy',
    expansion,
    forge,
    construction:expansion||forge,
    constructionGeometry:false,
    ecosystemArchitecture:false,
    landmark,
    structuralWriterCount,
  }
}
